import React from 'react'

import LogosBar from './logos-bar'
import UsaTodayColorLogo from '../../../frontend-lib/logos/UsaTodayColorLogo'
import ForbesColorLogo from '../../../frontend-lib/logos/ForbesColorLogo'
import BarronsColorLogo from '../../../frontend-lib/logos/BarronsColorLogo'
import AARPColorLogo from '../../../frontend-lib/logos/AARPColorLogo'
import CNBCColorLogo from '../../../frontend-lib/logos/CNBCColorLogo'
import KiplingerColorLogo from '../../../frontend-lib/logos/KiplingerColorLogo'
import NewYorkTimesLogo from '../../../frontend-lib/logos/NewYorkTimesLogo'
import { useIsMd } from '../../../theme/useIsMd'

function useLogosTop() {
  const isMdOrUp = useIsMd()
  const logos = [
    {
      id: 'UsaToday',
      logo: (
        <UsaTodayColorLogo
          width={isMdOrUp ? 78.25 : 62.67}
          height={isMdOrUp ? 78.33 : 64}
        />
      ),
    },
    {
      id: 'Forbes',
      logo: (
        <ForbesColorLogo
          width={isMdOrUp ? 132.71 : 87}
          height={isMdOrUp ? 34.78 : 24}
        />
      ),
    },
    {
      id: 'NewYorkTimes',
      logo: (
        <NewYorkTimesLogo
          width={isMdOrUp ? 200 : 100}
          height={isMdOrUp ? 100 : 90}
        />
      ),
    },
    {
      id: 'Barrons',
      logo: (
        <BarronsColorLogo
          width={isMdOrUp ? 192.7 : 89}
          height={isMdOrUp ? 40.99 : 18.93}
        />
      ),
    },
    {
      id: 'AARP',
      logo: (
        <AARPColorLogo
          width={isMdOrUp ? 115.21 : 92.86}
          height={isMdOrUp ? 25.03 : 20}
        />
      ),
    },
    {
      id: 'CNBC',
      logo: (
        <CNBCColorLogo
          width={isMdOrUp ? 80.08 : 61.02}
          height={isMdOrUp ? 64 : 48.77}
        />
      ),
    },
    {
      id: 'Kiplinger',
      logo: (
        <KiplingerColorLogo
          width={isMdOrUp ? 158.67 : 90.96}
          height={isMdOrUp ? 48.9 : 28.03}
        />
      ),
    }
  ]

  return { logos }
}

function LogosTop() {
  const { logos } = useLogosTop()
  return (
    <LogosBar
      logos={logos}
      columns={{ xs: 4, sm: 4, md: 2, lg: 2 }}
      minWidth="130px"
    />
  )
}

export default LogosTop
